var React = require('react');

function LogoWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40 20c0 11-9 20-20 20S0 31 0 20 9 0 20 0s20 9 20 20zM24.3 30.3c0 .3.1.4.4.4h3.8c.3 0 .4-.1.4-.4v-7.5c0-.3-.2-.4-.4-.4h-4.4c-.3 0-.4.1-.4.4v.5s-.6 2.8-4 2.8c-1.3 0-2.1-.7-2.1-1.6 0-2.6 11.1-1.5 11.1-8.7 0-3.8-2.8-6.5-7.3-6.5-2.5 0-4.1.7-5.1 1.8l.1-1.2c0-.3-.1-.4-.4-.4h-3.8c-.3 0-.4.1-.4.4v7.5c0 .3.2.4.4.4h4.4c.3 0 .4-.1.4-.4v-.5c0-1.2 1.1-2.6 3.6-2.6 1.3 0 2.1.6 2.1 1.5 0 3.2-11.8 1.6-11.8 8.9 0 3.1 2.1 6.3 7.3 6.3 4 0 6.1-2.1 6.2-2.1l-.1 1.4z"}));
}

LogoWhite.defaultProps = {"viewBox":"0 0 40 40"};

module.exports = LogoWhite;

LogoWhite.default = LogoWhite;
